<template>
  <div class="py-6 px-8">
    <h-header back="../appointments">
      <template v-slot:actions>
        <v-btn
            v-if="currentTab === 2"
            @click="pintQuestionnaire"
            color="primary"
            elevation="0"
            class="ml-3"
          >
          <v-icon left>mdi-printer</v-icon>
          <span class="d-none d-md-flex body-2">
            {{ $t('questionnaire.actions.print') }}
          </span>
        </v-btn>
      </template>
    </h-header>

    <v-tabs v-model="currentTab" color="realEstate">
      <v-tab>{{ $t('appointment.details.tabs.details') }}</v-tab>
      <v-tab>{{ $t('appointment.details.tabs.history') }}</v-tab>
      <v-tab>{{ $t('appointment.details.tabs.questionary') }}</v-tab>
      <v-tab v-if="serviceReport">{{ $t('appointment.details.tabs.reportAndQuotes') }}</v-tab>
      <v-tab v-if="showDispute">{{ $t('board.actions.dispute') }}</v-tab>
    </v-tabs>

    <v-card elevation="0" outlined>
      <h-loading v-if="isLoading" />
      <v-tabs-items v-model="currentTab">
        <v-tab-item>
          <AppointmentServiceDetails v-show="!isLoading" />
        </v-tab-item>
        <v-tab-item>
          <AppointmentHistory />
        </v-tab-item>
        <v-tab-item>
          <AppointmentQuestionnaire />
        </v-tab-item>
        <v-tab-item v-if="serviceReport">
          <AppointmentReportAndQuotes />
        </v-tab-item>
        <v-tab-item v-if="showDispute">
          <AppointmentDispute />
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
import AppointmentServiceDetails from '@/components/appointment/AppointmentServiceDetails'
import AppointmentHistory from '@/components/appointment/AppointmentHistory'
import AppointmentQuestionnaire from '@/components/appointment/AppointmentQuestionnaire'
import AppointmentReportAndQuotes from '@/components/appointment/AppointmentReportAndQuotes'
import AppointmentDispute from '../components/appointment/AppointmentDispute.vue'

import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'AppointmentDetails',

  components: {
    AppointmentHistory,
    AppointmentServiceDetails,
    AppointmentQuestionnaire,
    AppointmentReportAndQuotes,
    AppointmentDispute,
  },

  data() {
    return {
      currentTab: 0,
      id: this.$router.currentRoute.params.id,
    }
  },

  computed: {
    ...mapGetters(['isLoading', 'serviceReport', 'appointment']),

    hasJobId() {
    const id = this.appointment?.job_id
    return typeof id === 'string' && id.trim().length > 0
  },

    isStatusDone() {
      return this.appointment?.status === 'DONE'
    },

    showDispute() {
      return !this.isLoading && this.hasJobId && this.isStatusDone
    },
  },

  methods: {
    ...mapActions([
      'fetchAppointment',
      'fetchAppointmentQuestionnaires',
      'fetchServiceReport',
    ]),

    pintQuestionnaire() {
      window.print()
    },
  },

  async mounted() {
    if (!this.id) return

    await Promise.all([
      this.fetchAppointment(this.id),
      this.fetchAppointmentQuestionnaires(this.id),
      this.fetchServiceReport(this.id),
    ])
  },
}
</script>
